<script setup>
    import { onMounted, ref } from 'vue'

    defineProps({
        modelValue: [String, Number],
    })

    defineEmits(['update:modelValue'])

    const input = ref(null)

    onMounted(() => {
        if (input.value.hasAttribute('autofocus')) {
            input.value.focus()
        }
    })

    defineExpose({ focus: () => input.value.focus() })
</script>

<template>
    <input
        ref="input"
        class="focus:border-brand-primary focus:ring-brand-primary rounded-md border border-gray-300 bg-white px-3 py-2 !text-black placeholder-gray-300 shadow-sm outline-none"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    />
</template>
